export default "### What if I don't want to sell my things? I like them.\n";